<template>
  <div id="app">
    <div id="wrapper">
      <div class="menu-icon" @click="sidebarIsOpen = !sidebarIsOpen" v-show="!sidebarIsOpen">
        <v-icon name="bars" scale="2"></v-icon>
      </div>
      <v-sidebar
        :links="sidebarLinks"
        :opened="sidebarIsOpen"
        @closeSideBar="toggleSidebar"
      ></v-sidebar>
      <div class="container">
        <router-view/>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      sidebarIsOpen: true,
      sidebarLinks: [
        {
          name: 'home',
          route: 'Home'
        },
        {
          name: 'colorado route',
          route: 'ColoradoRoute'
        },
        {
          name: 'foottracks',
          route: 'Foottracks'
        },
        {
          name: 'works',
          route: 'Works',
          nested: [
            {
              name: 'peintures',
              route: 'Peintures',
              params: { tab: 'works1980-1990' }
            },
            {
              name: 'installations',
              route: 'Installations'
            }
          ]
        },
        {
          name: 'latest walkabouts',
          route: 'LatestWalkabouts'
        },
        {
          name: 'colorado sounds',
          route: 'ColoradoSounds',
          nested: [
            {
              name: 'galleries',
              route: 'Galleries'
            }
          ]
        },
        {
          name: 'contact',
          route: 'Contact'
        }
      ]
    }
  },
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$windowWidth = window.innerWidth
      this.$windowWidth < 1200
        ? this.sidebarIsOpen = false
        : this.sidebarIsOpen = true
    },
    toggleSidebar (bool) {
      console.log('toogle sidebar', bool)
      if (this.$windowWidth < 1200) {
        this.sidebarIsOpen = bool
      }
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  font-family: "Lucida Sans unicode", sans-serif;
  #app {
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    min-height: 100vh;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    #wrapper {
      display: flex;
      flex: 1 0 auto;
    }
    .container {
      padding: 30px 50px 50px 50px;
      width: 100%;
    }
    .menu-icon {
      cursor: pointer;
      position: absolute;
      left: 10px;
      top: 10px;
      color: #835e0f;
    }
  }
}
@media screen and (max-width: 1200px) {
  body {
    #app {
      .container {
        padding: 50px 50px 50px 70px;
      }
    }
  }
}
@media screen and (max-width: 500px) {
  body {
    #app {
      .container {
        padding: 50px 5px;
      }
    }
  }
}
</style>
